// Keep in sync with railsapi/app/models/tenant.rb::INTERNAL_DOMAINS
const INTERNAL_EMAIL_DOMAINS = new Set([
  "habitsrob.onmicrosoft.com",
  "getrhythms.ai",
  "rhythms.ai",
])

export function isInternalEmail(email: string): boolean {
  const domain = email.split("@")[1]?.toLowerCase()
  return domain ? INTERNAL_EMAIL_DOMAINS.has(domain) : false
}
